import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ShoppingCart, Menu, X, User, LogOut, LogIn } from "lucide-react";
import { useCart } from "../context/CartContext";
import { useCustomerAuth } from "../context/CustomerAuthContext";

const LOGO = "https://customer-assets-0z36b82j.emergentagent.net/job_gray-spirit-gear/artifacts/qoih72dz_glogo.jpeg";

const CATEGORIES = [
  { slug: "shop-all", label: "Shop All" },
  { slug: "player-gear", label: "Player Gear" },
  { slug: "parents-family", label: "Parents & Family" },
  { slug: "fan-gear", label: "Fan Gear" },
  { slug: "varsity", label: "Varsity" },
  { slug: "jv", label: "JV" },
  { slug: "middle-school", label: "Middle School" },
  { slug: "schedule", label: "Schedule", path: "/schedule" },
  { slug: "senior-night", label: "Senior Night", path: "/senior-night/sasha-hughes" },
  { slug: "faq", label: "FAQ", path: "/faq" },
  { slug: "team-stores", label: "Team Stores", path: "/team-stores" },
];

export const Header = () => {
  const { count } = useCart();
  const { user, login, logout } = useCustomerAuth();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-50 bg-[#0A0A0A]/95 backdrop-blur-md border-b border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" data-testid="header-logo" className="flex items-center gap-2">
            <img src={LOGO} alt="GCA War Eagles" className="w-9 h-9 rounded-full bg-white object-contain" />
            <span className="flex flex-col leading-none">
              <span className="font-display text-2xl sm:text-3xl">GCA <span className="text-[var(--gv-blue-bright)]">VOLLEYBALL</span></span>
              <span className="text-[9px] sm:text-[10px] uppercase tracking-[0.2em] text-gray-400 font-bold mt-0.5">Gray Collegiate Academy • War Eagles</span>
            </span>
          </Link>
          <nav className="hidden lg:flex items-center gap-6">
            {CATEGORIES.map((c) => (
              <Link key={c.slug} to={c.path || `/shop/${c.slug}`} data-testid={`nav-${c.slug}`}
                className="text-xs uppercase tracking-[0.15em] font-bold text-gray-300 hover:text-[var(--gv-blue-bright)] transition-colors">
                {c.label}
              </Link>
            ))}
          </nav>
          <div className="flex items-center gap-3">
            {user ? (
              <>
                <Link to="/account" data-testid="header-account-link" className="flex items-center gap-1 text-xs uppercase tracking-[0.15em] font-bold text-gray-200 hover:text-[var(--gv-blue-bright)] transition-colors">
                  <User className="w-5 h-5" /> <span className="hidden sm:inline">{(user.name || "Account").split(" ")[0]}</span>
                </Link>
                <button onClick={logout} data-testid="header-logout-btn" className="p-2 text-gray-400 hover:text-[var(--gv-blue-bright)] transition-colors" title="Log out">
                  <LogOut className="w-5 h-5" />
                </button>
              </>
            ) : (
              <button onClick={() => navigate("/account")} data-testid="header-signin-btn" className="flex items-center gap-1 text-xs uppercase tracking-[0.15em] font-bold text-gray-200 hover:text-[var(--gv-blue-bright)] transition-colors">
                <LogIn className="w-5 h-5" /> <span className="hidden sm:inline">Sign In</span>
              </button>
            )}
            <button onClick={() => navigate("/checkout")} data-testid="header-cart-btn" className="relative p-2 hover:text-[var(--gv-blue-bright)] transition-colors">
              <ShoppingCart className="w-6 h-6" />
              {count > 0 && <span data-testid="cart-count-badge" className="absolute -top-1 -right-1 bg-[var(--gv-blue)] text-black text-xs w-5 h-5 rounded-full flex items-center justify-center font-bold">{count}</span>}
            </button>
            <button className="lg:hidden p-2" data-testid="mobile-menu-btn" onClick={() => setOpen(!open)}>
              {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>
      </div>
      {open && (
        <div className="lg:hidden border-t border-white/10 bg-[#0A0A0A] px-4 py-3" data-testid="mobile-menu">
          {CATEGORIES.map((c) => (
            <Link key={c.slug} to={c.path || `/shop/${c.slug}`} onClick={() => setOpen(false)}
              className="block py-3 text-sm uppercase tracking-[0.15em] font-bold text-gray-200 border-b border-white/5 last:border-0">
              {c.label}
            </Link>
          ))}
        </div>
      )}
    </header>
  );
};
